export default __webpack_public_path__ + "static/media/TransportationCars_01.18ebfdc7.png";